import { render } from "./quill.vue?vue&type=template&id=32e53e0d&scoped=true"
import script from "./quill.vue?vue&type=script&lang=js"
export * from "./quill.vue?vue&type=script&lang=js"

import "./quill.vue?vue&type=style&index=0&id=32e53e0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e53e0d"]])

export default __exports__